/*
  nowbikes-variant-gallery.js  (assets/nowbikes-variant-gallery.js)
  ------------------------------------------------------------------
  Al seleccionar una variante, la galeria de la ficha de producto muestra SOLO
  las fotos de esa variante/color. No hace ninguna llamada de red: trabaja con
  el JSON que publica snippets/nowbikes-variant-gallery.liquid y con el DOM que
  ya renderiza Dawn (product-media-gallery + product-media-modal).

  Como decide de quien es cada foto (cascada de senales, la primera que acierta):
    1. Codigo de colorway Specialized al principio del nombre de fichero
       (^#####-##_ .. ^#####-####_), p.ej. "95727-53_levo-r-comp-alloy_hero.jpg".
       El colorway de la variante se toma de SU foto destacada (mas fiable que el
       SKU: en ~37% de las variantes el prefijo del SKU no coincide con el codigo
       del fichero). Si la variante no tiene foto destacada se usa el prefijo del
       SKU, y solo si ese codigo existe entre las fotos.
    2. SKU completo de una variante contenido en el nombre (por segmentos),
       p.ej. "00.4118.474.003_01.jpg" -> variante con SKU 00.4118.474.003.
       Si el producto tiene opcion de talla, el match se extiende a todas las
       variantes del mismo color (nunca se filtra por talla). Si tiene talla y no
       tiene color, la senal se descarta.
    3. Valor de la opcion de color contenido en el nombre (por segmentos),
       p.ej. "...-gold-001.webp" con opcion Color = "Gold".

  Guardarrailes:
    - Comparacion por segmentos completos, nunca substring suelto: "black" no
      casa con "jet-black". Si dos senales del mismo tipo empatan en longitud y
      apuntan a colores distintos, la foto se considera comun.
    - El filtrado solo se activa si quedan >= 2 grupos distintos con >= 1 foto.
    - Si la variante seleccionada no tiene ninguna foto propia se prueba con las
      de su color; si tampoco, NO se filtra (galeria completa). Nunca vacia.
    - Las fotos sin senal son comunes (visibles siempre), salvo las del import
      antiguo con nombre MD5 en productos que si tienen convencion (ver
      HIDE_LEGACY_HASH_IMAGES).

  Interruptores: ?nbgallery=off en la URL desactiva el filtrado sin desplegar.
  Depuracion:    window.NowbikesVariantGallery.debug(sectionId)
*/
(function () {
  'use strict';

  // --- interruptores -------------------------------------------------------
  // Senal 3 (nombre del color en el fichero). Ponlo a false para desplegar solo
  // las senales 1 y 2 (codigo de colorway + SKU).
  var ENABLE_COLOR_NAME_SIGNAL = true;
  // Las fotos con nombre hash MD5 son del import antiguo y en la practica son
  // duplicados del hero de UN color concreto (comprobado en el catalogo), asi
  // que en productos con convencion reconocible se ocultan al filtrar. Ponlo a
  // false para tratarlas como comunes (visibles siempre).
  var HIDE_LEGACY_HASH_IMAGES = true;

  var TOKEN_RE = /^(\d{5}-\d{2,4})[-_]/;
  var SKU_TOKEN_RE = /^(\d{5})-(\d{2,4})/;
  var HASH_RE = /^[0-9a-f]{32}([-_][0-9a-f][0-9a-f-]{5,})?$/;
  var COLOR_OPTION_RE = /^(color|colour|colores|colorway)$/;
  var SIZE_OPTION_RE = /(talla|size|tamano)/;
  var HIDDEN_ATTR = 'data-nb-gallery-hidden';
  var MIN_SKU_LENGTH = 5;
  var MIN_COLOR_LENGTH = 3;

  if (window.NowbikesVariantGallery) return;
  if (window.location.search.indexOf('nbgallery=off') !== -1) return;

  // --- utilidades ----------------------------------------------------------
  function normalize(value) {
    if (!value && value !== 0) return '';
    var text = String(value);
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function fileBase(name) {
    return String(name || '').replace(/\.[a-z0-9]{2,5}$/i, '');
  }

  // "casa como segmento completo": '-jet-black-'.includes('-black-') es true,
  // por eso ademas se queda siempre el match mas largo (ver bestMatch).
  function containsSegment(haystack, needle) {
    if (!needle || !haystack) return false;
    return ('-' + haystack + '-').indexOf('-' + needle + '-') !== -1;
  }

  function toSet(list) {
    var set = Object.create(null);
    for (var i = 0; i < list.length; i++) set[list[i]] = true;
    return set;
  }

  function setKeys(set) {
    return Object.keys(set).sort().join(',');
  }

  function isEmpty(set) {
    for (var k in set) if (Object.prototype.hasOwnProperty.call(set, k)) return false;
    return true;
  }

  // --- modelo --------------------------------------------------------------
  function buildModel(data) {
    var model = {
      section: String(data.section),
      active: false,
      owners: Object.create(null), // mediaId -> {variantId:true} | null (comun)
      legacy: Object.create(null), // mediaId -> true si nombre MD5
      colorOf: Object.create(null), // variantId -> color normalizado
      byColor: Object.create(null), // color -> {variantId:true}
      variants: data.variants || [],
      reason: ''
    };
    var media = data.media || [];
    var variants = model.variants;
    if (media.length < 2 || variants.length < 2) {
      model.reason = 'pocas fotos o variantes';
      return model;
    }

    // indices de las opciones de color y de talla
    var names = data.options || [];
    var colorIndex = -1;
    var sizeIndex = -1;
    for (var i = 0; i < names.length; i++) {
      var n = normalize(names[i]).replace(/-/g, ' ').trim().replace(/\s+/g, '-');
      if (colorIndex === -1 && COLOR_OPTION_RE.test(n)) colorIndex = i;
      if (sizeIndex === -1 && SIZE_OPTION_RE.test(n)) sizeIndex = i;
    }

    var v, j;
    for (j = 0; j < variants.length; j++) {
      v = variants[j];
      if (colorIndex === -1) continue;
      var color = normalize((v.o || [])[colorIndex]);
      if (color.length < 2 || /^\d+$/.test(color)) continue;
      model.colorOf[v.id] = color;
      if (!model.byColor[color]) model.byColor[color] = Object.create(null);
      model.byColor[color][v.id] = true;
    }

    // nombres de fichero normalizados
    var fileOf = Object.create(null);
    var tokenOf = Object.create(null);
    var tokens = Object.create(null);
    var tokenCount = 0;
    for (i = 0; i < media.length; i++) {
      var raw = fileBase(media[i].f || '');
      fileOf[media[i].id] = normalize(raw);
      model.legacy[media[i].id] = HASH_RE.test(normalize(raw));
      var m = TOKEN_RE.exec(raw);
      tokenOf[media[i].id] = m ? m[1] : null;
      if (m && !tokens[m[1]]) {
        tokens[m[1]] = true;
        tokenCount++;
      }
    }
    var tokenMode = tokenCount >= 2;

    // colorway de cada variante (senal 1)
    var variantToken = Object.create(null);
    if (tokenMode) {
      for (j = 0; j < variants.length; j++) {
        v = variants[j];
        var t = v.m ? tokenOf[v.m] : null;
        if (!t) {
          // respaldo: prefijo del SKU (95727-5502 -> 95727-55 / 95727-550 / 95727-5502),
          // probando del mas largo al mas corto y solo si ese codigo existe en las fotos
          var sm = SKU_TOKEN_RE.exec(v.sku || '');
          if (sm) {
            for (var d = sm[2].length; d >= 2; d--) {
              var candidate = sm[1] + '-' + sm[2].slice(0, d);
              if (tokens[candidate]) {
                t = candidate;
                break;
              }
            }
          }
        }
        if (t) variantToken[v.id] = t;
      }
    }

    // SKUs normalizados (senal 2)
    var skus = [];
    for (j = 0; j < variants.length; j++) {
      var sku = normalize(variants[j].sku);
      if (sku.length >= MIN_SKU_LENGTH) skus.push({ sku: sku, id: variants[j].id });
    }

    var colorList = Object.keys(model.byColor);

    for (i = 0; i < media.length; i++) {
      var id = media[i].id;
      var file = fileOf[id];
      var owners = null;
      var k;

      // 1) codigo de colorway
      if (tokenMode && tokenOf[id]) {
        owners = Object.create(null);
        for (k in variantToken) {
          if (variantToken[k] === tokenOf[id]) owners[k] = true;
        }
        model.owners[id] = owners; // puede quedar vacio: colorway sin variante
        continue;
      }

      // 2) SKU completo en el nombre
      var best = 0;
      var winners = [];
      for (k = 0; k < skus.length; k++) {
        if (!containsSegment(file, skus[k].sku)) continue;
        if (skus[k].sku.length > best) {
          best = skus[k].sku.length;
          winners = [skus[k].id];
        } else if (skus[k].sku.length === best) {
          winners.push(skus[k].id);
        }
      }
      if (winners.length) {
        if (sizeIndex !== -1 && colorIndex === -1) {
          model.owners[id] = null; // filtrar aqui separaria tallas: comun
          continue;
        }
        owners = Object.create(null);
        for (k = 0; k < winners.length; k++) {
          var color2 = model.colorOf[winners[k]];
          if (sizeIndex !== -1 && color2) {
            for (var sib in model.byColor[color2]) owners[sib] = true;
          } else {
            owners[winners[k]] = true;
          }
        }
        model.owners[id] = owners;
        continue;
      }

      // 3) nombre del color en el fichero
      if (ENABLE_COLOR_NAME_SIGNAL && colorList.length) {
        best = 0;
        var colorWinners = [];
        for (k = 0; k < colorList.length; k++) {
          var c = colorList[k];
          if (c.length < MIN_COLOR_LENGTH || !containsSegment(file, c)) continue;
          if (c.length > best) {
            best = c.length;
            colorWinners = [c];
          } else if (c.length === best) {
            colorWinners.push(c);
          }
        }
        if (colorWinners.length === 1) {
          owners = Object.create(null);
          for (var sib2 in model.byColor[colorWinners[0]]) owners[sib2] = true;
          model.owners[id] = owners;
          continue;
        }
        // empate entre colores distintos -> ambigua -> comun
      }

      model.owners[id] = null;
    }

    // activacion: >= 2 grupos distintos con >= 1 foto
    var signatures = Object.create(null);
    var groups = 0;
    for (var mediaId in model.owners) {
      var own = model.owners[mediaId];
      if (!own || isEmpty(own)) continue;
      var sig = setKeys(own);
      if (!signatures[sig]) {
        signatures[sig] = true;
        groups++;
      }
    }
    model.active = groups >= 2;
    if (!model.active) model.reason = 'solo ' + groups + ' grupo(s) de color';
    return model;
  }

  // ids de las fotos visibles para una variante, o null si no se debe filtrar
  function visibleMedia(model, variantId) {
    if (!model.active || !variantId) return null;
    var own = [];
    var mediaId;
    for (mediaId in model.owners) {
      var owners = model.owners[mediaId];
      if (owners && owners[variantId]) own.push(mediaId);
    }
    if (!own.length) {
      // respaldo: fotos de las variantes del mismo color
      var siblings = model.byColor[model.colorOf[variantId]];
      if (siblings) {
        for (mediaId in model.owners) {
          var owners2 = model.owners[mediaId];
          if (!owners2) continue;
          for (var sib in siblings) {
            if (owners2[sib]) {
              own.push(mediaId);
              break;
            }
          }
        }
      }
    }
    if (!own.length) return null; // sin fotos propias: galeria completa
    var visible = toSet(own);
    for (mediaId in model.owners) {
      if (model.owners[mediaId]) continue; // ya tratada
      if (HIDE_LEGACY_HASH_IMAGES && model.legacy[mediaId]) continue;
      visible[mediaId] = true; // foto comun
    }
    return visible;
  }

  // --- DOM -----------------------------------------------------------------
  function selectedVariantId(scope) {
    var node = scope.querySelector('variant-selects [data-selected-variant], [data-selected-variant]');
    if (node) {
      try {
        var parsed = JSON.parse(node.textContent);
        if (parsed && parsed.id) return String(parsed.id);
      } catch (e) {
        /* json vacio o roto: seguimos con los respaldos */
      }
    }
    var input = scope.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (input && input.value) return String(input.value);
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  function toggle(element, hidden) {
    if (!element) return false;
    var was = element.hasAttribute(HIDDEN_ATTR);
    if (hidden && !was) {
      element.setAttribute(HIDDEN_ATTR, '');
      return true;
    }
    if (!hidden && was) {
      element.removeAttribute(HIDDEN_ATTR);
      return true;
    }
    return false;
  }

  function mediaIdFrom(value, section) {
    if (!value) return null;
    var prefix = section + '-';
    return value.indexOf(prefix) === 0 ? value.slice(prefix.length) : value;
  }

  function applyToSection(entry) {
    var model = entry.model;
    var scope = entry.scope;
    if (!scope || !scope.isConnected) return;
    var gallery = scope.querySelector('media-gallery');
    var variantId = selectedVariantId(scope);
    var visible = model.active ? visibleMedia(model, variantId) : null;
    var changed = false;
    var shown = 0;
    var i;

    var slides = gallery ? gallery.querySelectorAll('li[data-media-id]') : [];
    for (i = 0; i < slides.length; i++) {
      var slideMedia = mediaIdFrom(slides[i].getAttribute('data-media-id'), model.section);
      var hide = !!visible && !visible[slideMedia];
      changed = toggle(slides[i], hide) || changed;
      if (!hide) shown++;
    }

    var thumbs = gallery ? gallery.querySelectorAll('li[data-target]') : [];
    for (i = 0; i < thumbs.length; i++) {
      var thumbMedia = mediaIdFrom(thumbs[i].getAttribute('data-target'), model.section);
      changed = toggle(thumbs[i], !!visible && !visible[thumbMedia]) || changed;
    }

    var modal = document.getElementById('ProductModal-' + model.section);
    if (modal) {
      var items = modal.querySelectorAll('.product-media-modal__content > [data-media-id]');
      for (i = 0; i < items.length; i++) {
        var modalMedia = mediaIdFrom(items[i].getAttribute('data-media-id'), model.section);
        changed = toggle(items[i], !!visible && !visible[modalMedia]) || changed;
      }
    }

    if (!gallery) return;
    // el contador y las flechas de Dawn cuentan los slides con ancho > 0, asi que
    // basta con recalcular las paginas despues de ocultar/mostrar.
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbSlider = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (viewer && typeof viewer.resetPages === 'function') viewer.resetPages();
    if (thumbSlider && typeof thumbSlider.resetPages === 'function') thumbSlider.resetPages();

    if (visible) {
      // si la foto activa era de otro color (p.ej. la variante nueva no tiene foto
      // destacada y Dawn no cambia de slide) saltamos a la primera visible: en el
      // layout de miniaturas solo se pinta la activa y el visor quedaria en blanco.
      var activeSlide = gallery.querySelector('li[data-media-id].is-active');
      if (activeSlide && activeSlide.hasAttribute(HIDDEN_ATTR)) {
        var firstVisible = gallery.querySelector('li[data-media-id]:not([' + HIDDEN_ATTR + '])');
        if (firstVisible && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(firstVisible.getAttribute('data-media-id'), false);
        }
      }

      // en layouts donde Dawn solo pinta un slide a la vez (thumbnail) initPages
      // se corta antes de refrescar el contador: lo ponemos nosotros.
      var total = gallery.querySelector('.slider-counter--total');
      var current = gallery.querySelector('.slider-counter--current');
      if (total) total.textContent = shown;
      if (current && (shown < 2 || parseInt(current.textContent, 10) > shown)) {
        current.textContent = shown ? 1 : 0;
      }
      var buttons = gallery.querySelector('.slider-buttons');
      if (buttons) toggle(buttons, shown < 2);
    }

    if (changed && viewer) {
      // en movil la tira es un carrusel: al ocultar slides hay que recolocarla
      var active = gallery.querySelector('li[data-media-id].is-active:not([' + HIDDEN_ATTR + '])');
      if (!active) active = gallery.querySelector('li[data-media-id]:not([' + HIDDEN_ATTR + '])');
      if (active && active.parentElement && active.parentElement.scrollTo) {
        active.parentElement.scrollTo({ left: active.offsetLeft });
      }
    }
  }

  // --- ciclo de vida -------------------------------------------------------
  var entries = [];

  function register(script) {
    if (script.nbGalleryBound) return null;
    script.nbGalleryBound = true;
    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
    var scope = script.closest('product-info') || script.parentElement;
    var entry = { model: buildModel(data), scope: scope, script: script };
    entries.push(entry);

    var gallery = scope && scope.querySelector('media-gallery ul');
    if (gallery && window.MutationObserver) {
      var pending = false;
      var observer = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          applyToSection(entry);
        });
      });
      observer.observe(gallery, { childList: true });
    }
    return entry;
  }

  function scan() {
    var scripts = document.querySelectorAll('script.nb-variant-gallery-data');
    for (var i = 0; i < scripts.length; i++) {
      var entry = register(scripts[i]);
      if (entry) applyToSection(entry);
    }
    entries = entries.filter(function (item) {
      return item.script.isConnected;
    });
  }

  function applyAll() {
    for (var i = 0; i < entries.length; i++) applyToSection(entries[i]);
  }

  window.NowbikesVariantGallery = {
    scan: scan,
    apply: applyAll,
    entries: entries,
    debug: function (sectionId) {
      for (var i = 0; i < entries.length; i++) {
        if (!sectionId || entries[i].model.section === String(sectionId)) return entries[i];
      }
      return null;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('product-info:loaded', function () {
    window.requestAnimationFrame(scan);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.requestAnimationFrame(applyAll);
    });
  }
})();
